// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"5e8649b1","498":"a931f95e","513":"09199374"}[chunkId] + ".chunk.js";
};